// extracted by mini-css-extract-plugin
module.exports = {"CarouselItemShortDescription":"CarouselItemDescription_CarouselItemShortDescription__2zofC","Cut":"CarouselItemDescription_Cut__21Xf2"};